import { GEO_ACTION_TYPES, GEO_FIELD_NAMES } from './actionTypes';

const initialState = {
    location: {
        [GEO_FIELD_NAMES.COUNTRY]: '',
        [GEO_FIELD_NAMES.COUNTRY_CODE]: 'RU',
        [GEO_FIELD_NAMES.REGION]: '',
        [GEO_FIELD_NAMES.REGION_CODE]: '',
        [GEO_FIELD_NAMES.CITY]: '',
        [GEO_FIELD_NAMES.LATITUDE]: null,
        [GEO_FIELD_NAMES.LONGITUDE]: null,
        [GEO_FIELD_NAMES.TIMEZONE]: 'Europe/Moscow',
        [GEO_FIELD_NAMES.ISP]: '',
    },
    isFetching: false,
    isLoaded: false,
    error: null,
};

export const geoReducer = (state = initialState, action) => {
    switch (action.type) {
        case GEO_ACTION_TYPES.REQUEST_LOCATION:
            return {
                ...state,
                isFetching: true,
                error: null,
            };

        case GEO_ACTION_TYPES.RECEIVE_LOCATION:
            return {
                ...state,
                location: {
                    ...state.location,
                    ...action.data,
                },
                isFetching: false,
                isLoaded: true,
                error: null,
            };

        case GEO_ACTION_TYPES.LOCATION_ERROR:
            return {
                ...state,
                isFetching: false,
                error: action.error,
            };

        case GEO_ACTION_TYPES.SET_REGION:
            return {
                ...state,
                location: {
                    ...state.location,
                    [GEO_FIELD_NAMES.REGION]: action.region,
                    [GEO_FIELD_NAMES.REGION_CODE]: action.regionCode,
                },
            };

        case GEO_ACTION_TYPES.SET_CITY:
            return {
                ...state,
                location: {
                    ...state.location,
                    [GEO_FIELD_NAMES.CITY]: action.city,
                },
            };

        case GEO_ACTION_TYPES.LOAD_FROM_STORAGE:
            return {
                ...state,
                location: {
                    ...state.location,
                    ...action.data,
                },
                isLoaded: true,
            };

        default:
            return state;
    }
};